import { render } from "./AbogTable.vue?vue&type=template&id=372a6673&scoped=true"
import script from "./AbogTable.vue?vue&type=script&lang=js"
export * from "./AbogTable.vue?vue&type=script&lang=js"

import "./AbogTable.vue?vue&type=style&index=0&id=372a6673&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-372a6673"]])

export default __exports__